module.exports = __webpack_public_path__ + "img/stock2.c17707dc.png";